export default {
  name: 'marking--xlsBrokerTemplateEnum',
};